import { EmployeeDetailTabs } from "./EmployeeDetailTabs";
import React from "react";
import {
  EmployeeDetailRoutes,
  EmployeeStartRoutes,
  EmployeeTeamRoutes,
} from "../Routes";
import { useParams } from "react-router-dom";
import { EmployeeDetailHeader } from "./EmployeeDetailHeader";
import { EmployeeTitle } from "./EmployeeTitle";
import { EmployeeTeamTabs } from "./EmployeeTeamTabs";

export const EmployeeDetail = ({ employee_id, myPage }) => {
  return (
    <div>
      <EmployeeTitle employee_id={employee_id} myPage={myPage} />
      <EmployeeStartRoutes employee_id={employee_id} />
    </div>
  );
};

export const EmployeeTeam = ({ employee_id }) => {
  return (
    <>
      <EmployeeTeamTabs />
      <EmployeeTeamRoutes employee_id={employee_id} />
    </>
  );
};

export const EmployeeInfo = ({ employee_id }) => {
  return (
    <>
      <EmployeeDetailHeader employee_id={employee_id} />
      <EmployeeDetailTabs />
      <EmployeeDetailRoutes employee_id={employee_id} />
    </>
  );
};

export const EmployeeDetailLayout = () => {
  const { employee_id } = useParams();

  return <EmployeeDetail employee_id={employee_id} />;
};
